import {
  AutopilotTaskDto,
  TaskCategoryTaskType,
} from '@urbanx/agx.activities.client'
import { JSX } from 'react'
import { GenericPendingBlocker } from './GenericPendingBlocker'
import { SettlementPendingBlocker } from './SettlementPendingBlocker'
import { UnconditionalPendingBlocker } from './UnconditionalPendingBlocker'

interface PendingTaskBlockerProps {
  task: AutopilotTaskDto
}

export const PendingTaskBlocker = ({ task }: PendingTaskBlockerProps): JSX.Element => {
  switch (task.category?.taskType) {
    case TaskCategoryTaskType.Settlement:
      return <SettlementPendingBlocker task={task} />
    case TaskCategoryTaskType.Unconditional:
      return <UnconditionalPendingBlocker task={task} />
    default:
      return <GenericPendingBlocker task={task} />
  }
}
